import React from 'react';

import { Text } from '@/nova/components';

import { Line, Root } from './ProviderDivider.styles';

export type ProviderDividerProps = {
  /** Divider copy override (English is the i18n key). Defaults to "Or continue with". */
  label?: string;
  className?: string;
};

/**
 * The "Or continue with" separator between the password form and the SSO bar. Purely presentational;
 * the text is a decorative label, not a heading. The default is a literal so i18next-cli extracts it.
 */
export const ProviderDivider = ({ label, className }: ProviderDividerProps): React.ReactElement => (
  <Root className={className}>
    <Line aria-hidden="true" />
    {label ? <Text text={label} /> : <Text text="Or continue with" />}
    <Line aria-hidden="true" />
  </Root>
);

export default ProviderDivider;
